module.exports = __webpack_public_path__ + "static/media/mixkit-bluish-data-center-hallway-23282-hd-ready.18b29e07.mp4";